<template>
	<div v-if="!isLoading && project !== null">
		
		
		<div style="margin-bottom: 50px;">
			<p v-if="!project.isPublished"><a @click="publishProjectHandler" class="button2">Опубликовать</a></p>
			<p v-else>Практика опубликована</p>
		</div>
		
		<div class="tabs">
			<ul>
				<li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Общая
					информация</a></li>
			</ul>
		</div>
		<Form ref="project_form" id="project_form" v-slot="{errors}">
			<div class="errors-block"
			     v-if="errors && Object.keys(errors).length > 0">
				<b>Пожалуйста, заполните поля:</b>
				<ul>
					<li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
						обязательно для заполнения
					</li>
				</ul>
			</div>
			
			
			<template v-if="isSubmitted">
				<Field style="display: none" v-model="project.name" name="name"
				       :rules="isRequired"></Field>
				<Field style="display: none" v-model="project.projectData.status" name="status"
				       :rules="isRequired"></Field>
				<Field style="display: none" v-model="project.annotation" name="annotation"
				       :rules="isRequired"></Field>
				<Field style="display: none" v-model="project.publishYear" name="publishYear"
				       :rules="isRequired"></Field>
			</template>
			
			
			<!--						<div v-if="!selectedCompetition?.name">-->
			<!--								<p class="help_text" @click="$parent.showModalQuestion"> <FontAwesomeIcon icon="question"></FontAwesomeIcon> Почему я не вижу обязательные поля для этого проекта?</p>-->
			<!--						</div>-->
			
			
			<div id="tabContent">
				<div v-if="tabNum === 1" class="content-tab">
					<div class="columns">
						<div class="column">
							<BaseInput3
								label="Название практики"
								v-model="project.name"
								@onChange="saveData"
								:is-required="true"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
							></BaseInput3>
							
							<BaseChoiseSelect
								label="Статус практики"
								v-model="project.projectData.status"
								:is-required="true"
								:values="[
                                {
                                  'value': 'Реализована',
                                  'label': 'Реализована'
                                },
                                {
                                  'value': 'В производстве',
                                  'label': 'В производстве'
                                }
															]"
								@onChange="saveData"
							></BaseChoiseSelect>
							
							<BaseInput3
								label="Год реализации"
								v-model="project.publishYear"
								@onChange="saveData"
								:is-required="true"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
							></BaseInput3>
							
							
							<TinymceEditor
								label="Общее описание практики"
								v-model="project.annotation"
								v-if="isFieldVisible('annotation')"
								:is-required="true"
								description="Общее описание практики"
								:isDataUpdating="isDataUpdating"
								@update="saveData"
							></TinymceEditor>
							
							<!--                            <div class="columns">-->
							<!--                                <div class="column">-->
							<!--                                    <div class="poster_wrapper">-->
							<!--                                        <ImageUpload-->
							<!--                                                label="Горизонтальное фото мероприятия (Формат jpeg/png. Макс. 1,5 мегабайт)"-->
							<!--                                                :image-name="project.afisha"-->
							<!--                                                image-path="https://script.moviestart.ru/uploads/images/"-->
							<!--                                                :is-data-updating="isDataUpdating"-->
							<!--                                                :entity-id="project.id"-->
							<!--                                                :aspect-ratio="546 / 366"-->
							<!--                                                description="Ссылка на скачивание постера фильма-->
							<!--                                * (ссылка должна быть действительна до даты окончания конкурса/акции)"-->
							<!--                                                @save-image="setPoster"-->
							<!--                                        ></ImageUpload>-->
							<!--                                    </div>-->
							<!--																</div>-->
							<!--                                <div class="column"></div>-->
							<!--                            </div>-->
							
							<BaseInput3
								label="Ссылка на тизер или трейлер проекта"
								v-model="project.projectData.poster_link"
								@onChange="saveData"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
							></BaseInput3>
							
							<div class="field" v-if="isFieldVisible('podderzhka')">
								<label :class="this.isFieldRequired('podderzhka') ? 'req': ''">Укажите, если проект поддержан
									Министерством культуры, Фондом кино, ПФКИ, ФПГ, ФПРК, ИРИ, Росмолодежь и др.</label>
								<textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
								          v-model="project.projectData.podderzhka"></textarea>
							</div>
						
						
						</div>
					</div>
				</div>
			</div>
		</Form>
	</div>
	<div v-else style="text-align: center">
		<div class="lds-default">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
</template>

<script>
import BaseInput3 from "../Base/BaseInput3.vue";
import TinymceEditor from "../Base/TinymceEditor.vue";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faQuestion} from '@fortawesome/free-solid-svg-icons';
import {message} from "ant-design-vue";
import Json from '@/services/json'
import {Field, Form} from 'vee-validate';


import {library} from '@fortawesome/fontawesome-svg-core';

library.add(faQuestion);
import 'cropperjs/dist/cropper.css';
import axios from "axios";
import ImageUpload from "@/components/Base/ImageUpload.vue";
import BaseChoiseSelect from "@/components/Base/BaseChoiseSelect.vue";

export default {
	name: 'OtherPractices',
	props: {
		selectedCompetition: {}
	},
	async created() {
		this.isLoading = true;
		//await this.checkIsUserFillProfile();
		
		if (window.projectId.length > 0) {
			this.project.id = window.projectId;
		}
		
		await this.getData()
		
		this.isLoading = false;
	},
	data() {
		return {
			imgSrc: '',
			isSubmitted: false,
			project: {
				name: '',
				publishYear: '',
				annotation: '',
				afisha: '',
				projectData: {
					poster_link: '',
					status: '',
					podderzhka: ''
				}
			},
			validationRules: [],
			isLoading: false,
			isDataUpdating: false,
			tabNum: 1,
			errors: [],
			isUserFillProfile: false,
			isFormSubmitted: false
		}
	},
	components: {
		BaseChoiseSelect,
		ImageUpload,
		BaseInput3,
		TinymceEditor,
		FontAwesomeIcon,
		Form,
		Field
	},
	methods: {
		setProjectFromResponse(projects_response) {
			projects_response.data = Json.replaceKeys(projects_response.data);
			projects_response.data.projectData = Json.handle_json_field(projects_response.data.projectData, this.project.projectData);
			
			this.project = projects_response.data;
		},
		async getData(checkErrors = true, showModal = false) {
			this.isDataUpdating = true;
			if ((this.project?.id && typeof this.project?.id === 'number') || (this.project?.id && typeof this.project?.id === 'string') && this.project?.id?.length > 0) {
				const projects_response = await axios.get('/api/projects/' + this.project.id + '.json');
				//this.project = projects_response.data;
				this.setProjectFromResponse(projects_response);
			}
			this.isDataUpdating = false;
		},
		handleEntityResponse(response) {
			if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
				alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
				window.location.reload();
			}
			this.setProjectFromResponse(response);
		},
		async createNewProject() {
			this.isDataUpdating = true;
			if (window.userid.length > 0 && window.isCompanyRole.length > 0) {
				
				this.project.user = "/api/users/" + window.userid;
				this.project.type = "practic";
				
				if (this.project?.publishYear?.length === 0) {
					delete this.project.publishYear;
				}
				
				const response = await axios.post('/api/projects', this.project);
				await this.handleEntityResponse(response);
				
				history.pushState(null, null, window.location.href + "/" + this.project.id);
				
			} else {
				message.error('Ошибка сохранения')
			}
			this.isDataUpdating = false;
		},
		async patchProject() {
			
			this.isDataUpdating = true;
			
			if (this.project.isPublished) {
				await this.publishProject();
			}
			
			const project_object = structuredClone(this.project);
			
			delete project_object.user;
			delete project_object.afisha;
			
			if (project_object.publishYear?.length === 0) {
				delete project_object.publishYear;
			} else {
				project_object.publishYear = parseInt(this.project.publishYear)
			}
			const response = await axios.patch('/api/projects/' + this.project.id, project_object, {
				headers: {
					'Content-Type': "application/merge-patch+json"
				}
			}).catch((event) => {
				alert(event.response.data['hydra:description']);
			})
			this.handleEntityResponse(response);
			if (this.isFormSubmitted) {
				this.checkErrors();
			}
			
			this.isDataUpdating = false;
		},
		saveData: async function () {
			this.$emit('saveBegin');
			if (!this.project.id) {
				await this.createNewProject();
			} else {
				await this.patchProject();
			}
			
			let is_valid = true;
			if (this.project.isPublished) {
				is_valid = await this.validate();
			}
			if (!is_valid) {
				await this.patchProject();
				this.getData();
			}
			this.$emit('saveEnd');
		},
		getFieldNameByIndex(index) {
			let res = '';
			if (index === 'name') {
				res = 'Название практики';
			} else if (index === 'status') {
				res = 'Статус практики';
			} else if (index === 'annotation') {
				res = 'Общее описание практики';
			} else if (index === 'publishYear') {
				res = 'Год реализации';
			}
			return res;
		},
		changeCurrentTab(num) {
			this.tabNum = num;
			document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
		},
		isRequired(value) {
			if (this.isSubmited === false) {
				return true;
			}
			if (value === null) {
				return false;
			}
			if (typeof value === 'number') {
				return value > 0;
			}
			if (Array.isArray(value)) {
				return value && value.length > 0;
			} else {
				return value && value.trim().length > 0;
			}
		},
		validateField(field) {
			const self = this;
			if (field.parentEntity !== undefined) {
				if (self.project) {
					if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0 || self.project[field.parentEntity][field.fieldName] === false))) {
						if (!self.errors.find(x => x.text === field.errorText)) {
							self.errors.push({
								text: field.errorText,
								order: field.order ? field.order : '1'
							});
						}
					}
				}
			} else {
				
				if (self.project) {
					if (field.isRequired && (self.project[field.fieldName] === null || self.project[field.fieldName]?.length === 0 || self.project[field.fieldName] === 0)) {
						if (!self.errors.find(x => x.text === field.errorText)) {
							self.errors.push({
								text: field.errorText,
								order: field.order ? field.order : '1'
							});
						}
					}
				}
			}
		},
		isFieldVisible(fieldName) {
			let res = true;
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					if ((field.fieldName === fieldName || field?.altFieldName === fieldName) && !field.isRequired && !field.isNeeded) {
						res = false;
					}
				});
			}
			return res;
		},
		isFieldRequired(fieldName) {
			let res = false;
			this.validationRules.forEach(function (field) {
				if (
					(field.fieldName === fieldName || field?.altFieldName === fieldName)
					&& field.isRequired) {
					res = true;
				}
			});
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					if (
						(field.fieldName === fieldName || field?.altFieldName === fieldName)
						&& field.isRequired) {
						res = true;
					}
				});
			}
			return res;
		},
		setImage(e) {
			const file = e.target.files[0];
			if (!file.type.includes("image/")) {
				alert("Загрузить можно только изображение");
				return;
			}
			if (file.size > 1572864) {
				alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
				return;
			}
			this.origfilename = file.name;
			const self = this;
			if (typeof FileReader === "function") {
				const reader = new FileReader();
				reader.onload = event => {
					self.imgSrc = event.target.result;
					// rebuild cropperjs with the updated source
					if (self.$refs.cropper) {
						self.$refs.cropper.replace(event.target.result);
					}
				};
				reader.readAsDataURL(file);
			} else {
				alert("Sorry, FileReader API not supported");
			}
		},
		async cropImage() {
			const self = this;
			
			this.$emit('saveBegin');
			if (!this.project.id) {
				await this.createNewProject();
			}
			this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
				let formData = new FormData();
				formData.append('file', blob);
				formData.append('original-name', self.origfilename);
				formData.append('current-name', self.project.afisha);
				formData.append('entity-id', self.project.id);
				
				axios(
					{
						method: 'post',
						url: '/project/getProjectAvatar',
						data: formData
					}
				)
					.then(() => {
						self.imgSrc = '';
						self.getData();
						
					});
			})
			this.$emit('saveEnd');
		},
		async setPoster(formData) {
			this.$emit('saveBegin');
			if (!this.project.id) {
				await this.createNewProject();
			}
			
			await axios(
				{
					method: 'post',
					url: '/project/getProjectAvatar',
					data: formData
				}
			);
			this.getData();
			this.$emit('saveEnd');
		},
		checkErrors(withScroll = true, showModal = false) {
			const self = this;
			this.isLoading = true;
			self.errors = [];
			
			this.validationRules.forEach(function (field) {
				self.validateField(field)
			});
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					self.validateField(field)
				});
				this.errors.sort((a, b) => a.order > b.order ? 1 : -1);
			}
			
			// if (!self.isUserFillProfile) {
			//   self.errors.push({
			//     text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/profile?check=true">https://script.moviestart.ru/profile</a>',
			//     order: '1'
			//   });
			// }
			if (showModal) {
				self.$parent.showModal();
			}
			self.isLoading = false;
			self.$parent.isLoading = false;
			if (withScroll && self.errors.length > 0) {
				if (document.getElementById("project_form")) {
					document.getElementById("project_form").scrollIntoView();
				}
			}
		},
		checkIsUserFillProfile() {
			return new Promise((resolve, reject) => {
				const self = this;
				axios.get('/isUserFillProfile', {
					headers: {
						'Accept': 'application/json',
					}
				})
					.then(response => {
						self.isUserFillProfile = response.data;
						resolve(response.data)
					})
					.catch(error => {
						console.log(error);
						reject(error)
					});
			});
		},
		async loadCountries() {
			const response = await axios.get('/get_all_countries', {
				headers: {
					'Accept': 'application/json',
				}
			})
			this.countriesinput = response.data;
		},
		loadCities() {
			const self = this;
			const current_country = self.countriesinput.filter(function (el) {
				return el["ru_name"] === self.project.country;
			})
			if (current_country[0] && current_country[0].number) {
				axios.get('/get_world_cities/' + current_country[0].number, {
					headers: {
						'Accept': 'application/json',
					}
				}).then((response) => {
					self.citiestoinput = response.data;
				}).catch(error => {
					console.log(error);
				});
			}
		},
		production_country_change(val) {
			this.project.projectData.production_country = val;
			this.saveData();
		},
		async validate() {
			const valid = await this.$refs.project_form.validate();
			let is_valid = false;
			
			if (valid.errors && Object.keys(valid.errors).length > 0) {
				if (this.project.isPublished) {
					this.project.isPublished = false;
				} else {
					if (document.getElementById("project_form")) {
						document.getElementById("project_form").scrollIntoView();
					}
				}
			} else {
				is_valid = true;
				this.project.isPublished = true;
			}
			return is_valid;
		},
		async publishProjectHandler() {
			await this.publishProject();
			this.saveData();
		},
		async publishProject() {
			this.isSubmitted = true;
			await this.$nextTick();
			const is_valid = await this.validate();
			if (is_valid) {
				this.project.isPublished = true;
			} else {
				this.project.isPublished = false;
			}
		}
	},
	computed: {},
	watch: {
		selectedCompetition(val) {
			this.checkErrors();
		},
		errors(val) {
			this.$emit('onErrorsChange', this.errors)
		}
	}
}
</script>

<style scoped>
.field_description {
	font-size: 13px;
}

.modal {
	display: block;
	width: 80%;
	max-width: 950px;
	padding: 30px;
	box-sizing: border-box;
	background-color: #fff;
	font-size: 20px;
	text-align: center;
	margin: 30px auto 30px;
	position: relative;
}

.category_select_active {
	font-weight: bold;
}

.close_button {
	position: absolute;
	right: 15px;
	top: 10px;
	font-size: 20px;
	cursor: pointer;
}

.vue-universal-modal {
	z-index: 111;
}

.errors-block {
	color: red;
	border: 1px solid #999;
	border-radius: 10px;
	padding: 25px;
	margin-bottom: 30px;
}

.lds-default {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
	transform: scale(0.5);
	text-align: center;
}

.lds-default div {
	position: absolute;
	width: 6px;
	height: 6px;
	background: #000;
	border-radius: 50%;
	animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
	animation-delay: 0s;
	top: 37px;
	left: 66px;
}

.lds-default div:nth-child(2) {
	animation-delay: -0.1s;
	top: 22px;
	left: 62px;
}

.lds-default div:nth-child(3) {
	animation-delay: -0.2s;
	top: 11px;
	left: 52px;
}

.lds-default div:nth-child(4) {
	animation-delay: -0.3s;
	top: 7px;
	left: 37px;
}

.lds-default div:nth-child(5) {
	animation-delay: -0.4s;
	top: 11px;
	left: 22px;
}

.lds-default div:nth-child(6) {
	animation-delay: -0.5s;
	top: 22px;
	left: 11px;
}

.lds-default div:nth-child(7) {
	animation-delay: -0.6s;
	top: 37px;
	left: 7px;
}

.lds-default div:nth-child(8) {
	animation-delay: -0.7s;
	top: 52px;
	left: 11px;
}

.lds-default div:nth-child(9) {
	animation-delay: -0.8s;
	top: 62px;
	left: 22px;
}

.lds-default div:nth-child(10) {
	animation-delay: -0.9s;
	top: 66px;
	left: 37px;
}

.lds-default div:nth-child(11) {
	animation-delay: -1s;
	top: 62px;
	left: 52px;
}

.lds-default div:nth-child(12) {
	animation-delay: -1.1s;
	top: 52px;
	left: 62px;
}

.competition_wrapper {
	position: relative;
	max-width: 355px;
}

.modal .columns.is-multiline {
	justify-content: center;
}

.modal .columns.is-multiline .col1 {
	margin-right: 50px;
	margin-bottom: 70px;
}

.competiton_order_button_div {
	display: none;
}

.competition-info {
	background: #FEF4E5;
	padding: 20px;
}

.competition-image-wrapper {
	position: relative;
	display: flex;
	border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
	font-size: 21px;
}

.vue-universal-modal {
	z-index: 111;
}

.competition-title__wrapper {
	line-height: 1;
}

.competition-title {
	font-size: 16px;
}

.category_select {
	font-size: 18px;
}

.content_block .tabs ul {
	align-items: inherit;
}

.content_block .tabs ul li {
	display: flex;
}

.category_select:hover {
	color: #F69F22;
	cursor: pointer;
}

.competition_wrapper_inner:hover .competiton_order_button_div {
	display: block;
}

.help_text {
	margin-bottom: 30px;
	margin-top: 30px;
	font-style: italic;
	color: #8F9194;
	cursor: pointer;
}

.help_text svg {
	margin-right: 10px;
}

.modal_question {
	text-align: left;
	font-size: 16px;
}

@keyframes lds-default {
	0%, 20%, 80%, 100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.5);
	}
}
</style>
